// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__fD13Y","list":"styles_list__1JGEe"};